var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3332 19.5556C11.3332 21.2737 12.7261 22.6667 14.4442 22.6667H17.3332C19.1741 22.6667 20.6665 21.1743 20.6665 19.3333C20.6665 17.4924 19.1741 16 17.3332 16H14.6665C12.8256 16 11.3332 14.5076 11.3332 12.6667C11.3332 10.8257 12.8256 9.33332 14.6665 9.33332H17.5554C19.2736 9.33332 20.6665 10.7262 20.6665 12.4444M15.9998 7.33332V9.33332M15.9998 22.6667V24.6667M29.3332 16C29.3332 23.3637 23.3636 29.3333 15.9998 29.3333C8.63604 29.3333 2.6665 23.3637 2.6665 16C2.6665 8.63619 8.63604 2.66666 15.9998 2.66666C23.3636 2.66666 29.3332 8.63619 29.3332 16Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.ebe909fcfe756fd22bae29e49e1c6389.svg";
export { ForwardRef as ReactComponent };